(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-valle-de-moreno"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-salsa-carousel')) {
    customElements.define('vm-salsa-carousel', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.events?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.finishTransition?.();
      }
      init() {
        this.events?.abort();
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.finishTransition?.();
        this.events = new AbortController();
        const options = { signal:this.events.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        if (this.slides.length !== 2) return;
        this.index = 0;
        this.visible = false;
        this.hovering = false;
        this.animating = false;
        this.start = null;
        this.seconds = 4;
        this.duration = 800;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.slides.forEach((slide,i) => {
          slide.hidden = i !== 0;
          slide.inert = i !== 0;
          slide.setAttribute('aria-hidden', String(i !== 0));
        });
        this.querySelector('[data-controls]').hidden = false;
        this.play = this.querySelector('[data-play]');
        this.play.hidden = this.dataset.autoplay !== 'true';
        this.addEventListener('click', event => {
          const control = event.target.closest('button');
          if (!control || !this.contains(control)) return;
          if (control.hasAttribute('data-play')) {
            this.paused = !this.paused;
            this.syncPlay();
            this.schedule();
          } else if (control.hasAttribute('data-index')) {
            this.go(Number(control.dataset.index), true);
          }
        }, options);
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          const destinations = { ArrowRight:this.index+1, ArrowLeft:this.index-1, Home:0, End:1 };
          if (event.key in destinations) {
            event.preventDefault();
            this.go(destinations[event.key], true);
          }
        }, options);
        this.addEventListener('pointerdown', event => {
          if (!event.isPrimary || this.animating || event.pointerType === 'mouse' || event.target.closest('a,button')) return;
          this.start = { x:event.clientX, y:event.clientY, id:event.pointerId };
          clearTimeout(this.timer);
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const x = event.clientX-this.start.x;
          const y = event.clientY-this.start.y;
          this.start = null;
          if (Math.abs(x)>40 && Math.abs(x)>Math.abs(y)*1.4) {
            this.go(this.index+(x<0 ? 1 : -1), true);
          } else this.schedule();
        }, options);
        this.addEventListener('pointercancel', () => { this.start = null; this.schedule(); }, options);
        this.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType==='mouse') { this.hovering=true; this.schedule(); }
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType==='mouse') { this.hovering=false; this.schedule(); }
        }, options);
        this.addEventListener('focusin', event => {
          if (event.target.closest('[data-play]')) { clearTimeout(this.timer); return; }
          if (event.target.matches(':focus-visible')) { this.paused=true; this.syncPlay(); this.schedule(); }
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.paused = true;
            this.finishTransition?.();
          }
          this.syncPlay();
          this.schedule();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible=entries[0].isIntersecting;
          this.schedule();
        }, {threshold:0.15});
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.fitText());
        this.resizeObserver.observe(this);
        document.fonts?.ready.then(() => { if(this.isConnected) this.fitText(); });
        this.go(0, false);
      }
      go(index, manual) {
        if (this.animating) return;
        const next = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        const previous = this.index;
        const outgoing = this.slides[previous];
        const incoming = this.slides[next];
        const direction = index < previous ? -1 : 1;
        clearTimeout(this.timer);
        if (next === previous) {
          this.updateControls(manual);
          this.fitText();
          this.schedule();
          return;
        }
        if (outgoing.contains(document.activeElement)) this.dots[next].focus();
        this.index = next;
        incoming.hidden = false;
        outgoing.inert = true;
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.inert = true;
        incoming.setAttribute('aria-hidden', 'false');
        this.fitText();
        this.updateControls(manual);
        if (this.motion.matches) {
          outgoing.hidden = true;
          incoming.inert = false;
          this.schedule();
          return;
        }
        this.animating = true;
        const settings = {
          duration:this.duration,
          easing:'cubic-bezier(0.22, 0.61, 0.36, 1)',
          fill:'forwards'
        };
        const animations = [
          outgoing.animate([
            { transform:'translate3d(0,0,0)' },
            { transform:'translate3d(' + (-direction*100) + '%,0,0)' }
          ], settings),
          incoming.animate([
            { transform:'translate3d(' + (direction*100) + '%,0,0)' },
            { transform:'translate3d(0,0,0)' }
          ], settings)
        ];
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          outgoing.hidden = true;
          incoming.inert = false;
          animations.forEach(animation => animation.cancel());
          this.animating = false;
          this.finishTransition = null;
        };
        this.finishTransition = finish;
        Promise.all(animations.map(animation => animation.finished)).then(finish, finish);
        this.schedule();
      }
      updateControls(manual) {
        this.dots.forEach((dot,i) => dot.setAttribute('aria-pressed', String(i===this.index)));
        if (manual) {
          this.querySelector('[data-status]').textContent = this.index===0
            ? 'Imagen 1 de 2: portada'
            : 'Imagen 2 de 2: sabores y productos';
        }
        this.syncPlay();
      }
      fitText() {
        this.querySelectorAll('.vm-carousel__title, .vm-carousel__flavors').forEach(text => {
          if (!text.offsetWidth) return;
          text.style.fontSize = '';
          const size = parseFloat(getComputedStyle(text).fontSize);
          const available = text.parentElement.clientWidth;
          if (text.scrollWidth>available) text.style.fontSize = (size*available/text.scrollWidth*.98)+'px';
        });
      }
      syncPlay() {
        this.play.setAttribute('aria-label', this.paused ? 'Iniciar cambio automático' : 'Pausar cambio automático');
        this.play.classList.toggle('is-paused', this.paused);
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || !this.visible || this.hovering || this.start || document.hidden || !this.isConnected) return;
        this.timer = setTimeout(() => this.go(this.index+1, false), this.seconds*1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
